import { TAX_LIST, CREATE_LIST, TAX_SINGLE, TAX_UPDATE, CLEAR_TEMP_DATA, TAX_DELETE, CLEARE_TEMP_TAX_DATA } from "src/Helper/actionsTypes";
import { CRTMSG, DELMSG, UPTMSG } from '../../../Helper/toastmsg'

const TaxReducer = (state = [], action) => {
    switch (action.type) {
        case TAX_LIST: {
            return action.payload.code === 200
                ? { ...state, list: action.payload.results }
                : { ...state, list: [], getMsg: action.payload.message }
        }
        case CREATE_LIST: {
            if (action.payload.code === 200) return { ...state, itemSaved: true, update: action.payload };
            else if (action.payload.code === 500) return { ...state, itemSaved: false, update: { message: CRTMSG } };
            else if (action.payload.code === 404) return { ...state, badReq: true, update: action.payload }
            else return { ...state, itemSaved: false, update: action.payload };
        }
        case TAX_SINGLE: {
            if (action.payload.code === 200) return { ...state, single: action.payload.results[0] }
            else if (action.payload.code === 404) return { ...state, badReq: true, update: action.payload }
            else return { ...state, single: {} }
        }
        case TAX_UPDATE: {
            if (action.payload.code === 500) return { ...state, itemUpdated: false, update: { message: UPTMSG } }
            else if (action.payload.code === 200) return { ...state, itemUpdated: true, update: action.payload }
            else if (action.payload.code === 404) return { ...state, badReq: true, update: action.payload }
            else return { ...state, itemUpdated: false, update: action.payload }
        }
        case TAX_DELETE: {
            if (action.payload.code === 500) return { ...state, itemDeleted: false, delMsg: { message: DELMSG } }
            else if (action.payload.code === 200) return { ...state, itemDeleted: true, delMsg: action.payload }
            else if (action.payload.code === 404) return { ...state, badReq: true, delMsg: action.payload }
            else return { ...state, itemDeleted: false, delMsg: action.payload }
        }
        case CLEARE_TEMP_TAX_DATA: {
            return { ...state, itemDeleted: null, itemUpdated: null, itemSaved: null, delMsg: null, getMsg: null, badReq: null }
        }
        case CLEAR_TEMP_DATA: {
            return {}
        }
        default: return state
    }
}
export default TaxReducer